import { render, staticRenderFns } from "./Asambleas.vue?vue&type=template&id=023d3707&scoped=true"
import script from "./Asambleas.vue?vue&type=script&lang=js"
export * from "./Asambleas.vue?vue&type=script&lang=js"
import style0 from "./Asambleas.vue?vue&type=style&index=0&id=023d3707&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d3707",
  null
  
)

export default component.exports